import axiosInstance from '@/api/axiosInstance';
import { CreatePathRequest, LearningPathResponse } from '@/modules/learningCenter/features/LearningPaths/apiTypes';

/**
 * Create a new learning path
 * POST /api/learning-paths
 * Requires ROLE_LEARNING_ADMIN or ROLE_SUPER_ADMIN
 * Returns the created learning path with courses and milestones
 */
export const createLearningPath = async (
  payload: CreatePathRequest
): Promise<LearningPathResponse> => {
  try {
    const response = await axiosInstance.post<{data: any}>(
      '/api/learning-paths',
      payload
    );

    // Backend wraps response in {data: ...}, need to unwrap it
    const pathData = response.data.data;

    // Transform to expected format
    return {
      path: pathData,
      courses: [],
      milestones: [],
    } as LearningPathResponse;
  } catch (error: any) {
    console.error('=== ERROR ===');
    console.error('Error object:', error);
    console.error('Response:', error.response);
    console.error('Response data:', error.response?.data);
    console.error('Response status:', error.response?.status);
    console.error('Response headers:', error.response?.headers);

    if (error.response?.data?.errors) {
      console.error('Validation errors:', JSON.stringify(error.response.data.errors, null, 2));
    }

    throw error;
  }
};
